import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const importrequirementApi = createApi({
  reducerPath: "importrequirementApi",
  baseQuery,
  tagTypes: ["Requirement"],
  endpoints: (builder) => ({

    getRequirementByMasterId: builder.query({
      query: ({id}) => `import/requirements/${id}`,
      transformResponse: (response) => {   
      const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item) => ({
          ...item,
          id: item.importRequirementId, 
        }));
      },
      providesTags: ["Requirement"],
    }),


    createRequirement: builder.mutation({
      query: ({ id, ...data}) => ({
        url: `import/requirements/${id}`,
        method: "PUT", 
        body: { importRequirement : data},
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        }, 
      }),
      invalidatesTags: ["Requirement"],
    }),

    updateRequirement: builder.mutation({
      query: ({id,subId, ...data }) => ({
        url: `import/requirements/${id}/${subId}`,
        method: "PUT",
        body: { importRequirement : data},
         headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        }, 
      }),
      invalidatesTags: ["Requirement"],
    }),

    deleteRequirement: builder.mutation({
      query: ({ id }) => ({
        url: `import/requirements/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["Requirement"],
    }),
  }),
});

export const {
  useLazyGetRequirementByMasterIdQuery,
  useCreateRequirementMutation,
  useUpdateRequirementMutation,
  useDeleteRequirementMutation,
} = importrequirementApi;
